module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sendFormTime ? 'form-submit load' : 'form-submit'
  }, [_c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._t("default", [_vm._v("Button name")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b43cbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/submit.vue
// module id = 249
// module chunks = 35